// @version 2.8.5
// @updated 2026-06-22
// hk-flickity-carousel — Flickity カルーセル（carousel-flickity セクション / hk-grid-group）
//
// Changelog:
// - 2.8.5: デザインモード — block/section 更新時は refresh（再 init）に統一。syncLayout のみだとセル DOM 差し替え後に崩れる
// - 2.8.4: selectActiveCell — selectCell 直後に reposition（SP アンカー同期でスライド位置がずれる不具合）
// - 2.8.3: アンカー連携 — location.hash の id を active 初期選択、engageUserNavigation() 公開
// - 2.8.2: selectActiveCell — 死んだ once(ready) を廃止（scheduleSelect 後 rAF で reinforce）、uiChange でキーボード操作も userEngaged
// - 2.8.1: selectActiveCell — once(settle) を廃止（初回操作の settle まで保留されていた）、初期同期フェーズを時間で終了
// - 2.8.0: selectActiveCell — ユーザー操作後は reinforce を停止（作品ページ等でスワイプが戻る不具合）
// - 2.7.9: セル数 — Flickity 初期化後は .flickity-slider / .hk-flickity-cell を数える（矢印が消える不具合）
// - 2.7.8: stretch — 全セルへ min-height 適用、高さ unchanged でも未同期セルを揃える
// - 2.7.7: stretch 高さ同期 — resize 連鎖ループを遮断、imagesLoaded progress を debounce
// - 2.7.6: 閉じた dialog / hidden 祖先では init 延期、initWhenVisible の不要 reinit を抑制（forced reflow 軽減）
// - 2.7.5: dragThreshold 12（公式）— 縦スクロール意図時の誤ドラッグを抑制。data-drag-threshold で上書き可
// - 2.7.4: グローバル init を hk-category-tabs:ready 待ちに変更、initWhenVisible は 0 幅時リトライ
// - 2.7.3: hk-tab-target — hidden 解除時に initWhenVisible（MutationObserver + 公開 API）
// - 2.7.2: hk-tab-target — hidden / タブ未初期化のみ init 延期（visibility 判定を廃止）
// - 2.7.1: hk-tab-target 非表示中は Flickity init を延期（タブ切替後 refresh で正しい幅で初期化）
// - 2.7.0: stretch 高さ計測 — height:100% メディアの 0px 誤計測を修正、モーダル注入後の再同期
// - 2.6.0: peek scroll 跳ね — CSS transform 中心化が本体。JS は矢印 focus 抑制と active 初期 select のみ
// - 2.5.9: スライド時に window スクロールが跳ねるのを防止（100vw breakout / focus 対策）
// - 2.5.8: hk-grid-group — 入れ子 group-block / MOカード内パーツをセル化しない（.hk-flickity-cell マーキング）
// - 2.5.7: デザインモード — track/class 監視を廃止、操作・init 中は refresh 抑制（スライド不能を修正）
// - 2.5.6: selectActiveCell — initialIndex 先行指定・親セル解決・settle/resize 後再 select
// - 2.5.5: デザインモード — 設定変更時に section:load / block:select / MutationObserver で refresh
// - 2.5.3: .hk-mo-card--active セルも初期 select 対象に追加
// - 2.5.2: .hk-artwork-series-card--active セルを初期 select（作品シリーズナビ）
// - 2.5.1: destroyPkgdGhost を削除（js-flickity 廃止で pkgd 自動 init が走らないため不要）
// - 2.5.0: js-flickity クラスを廃止（Flickity pkgd の htmlInit 二重初期化を防止）
// - 2.4.5: init 前に customElements.upgrade（モーダル注入後の hk-flickity-carousel 対応）
// - 2.4.4: セル数カウント — トラック内の入れ子セルのみ除外（group-block 祖先で誤除外しない）
// - 2.4.3: セル数は最外 hk-mo-media--cell のみカウント、動画 loadedmetadata で resize、init を rAF 待ち
// - 2.4.2: 空セル除外ロジックを削除（hk-mo-media-render が空メディアを出力しないため）
// - 2.4.1: syncChrome() 公開・init で Flickity 未読込でも矢印/単一セル状態を同期
// - 2.4.0: js-flickity クラス + HkFlickity.init(scope) でスキャン初期化（モーダル注入後も同一 API）
// - 2.3.5: refresh() 公開、fetch 注入後の初期化・load 後接続に対応
// - 2.3.4: hk-grid-group — セル1件のとき Flickity 非初期化・矢印非表示
// - 2.3.3: hk-mo-media — .hk-mo-media--cell をセルセレクタに追加（.card 非依存）
// - 2.3.2: hk-metaobject-cards — .hk-mo-cards__card をセルセレクタに追加
// - 2.3.1: hk-grid-group — cellSelector から > を除去（Flickity は matches() のため > が効かない）
// - 2.3.0: hk-grid-group — トラック直接子の .group-block もセル化（> .group-block）
// - 2.2.0: stretch（塗りつぶし）— 自然高さ計測後に全セルを同高 px 化（height:100% ループを回避）
// - 2.1.0: viewport 手動 height 設定を削除（stretch+100% で高さが膨張する不具合）
// - 2.0.0: 幅リサイズは Flickity 標準に任せる（ResizeObserver・手動 resize ループを削除）
// - 1.15.0: hk-grid-group 対応（レイアウトモード切替・作品シリーズカードセレクタ）
// - 1.14.0: ループ時の z-index 動的変更を削除（作品シリーズで重なり順が見える原因）
// - 1.13.0: ループ時のセル z-index 同期・遷移中 overflow クリップ（スライド重なり防止）
// - 1.12.0: 矢印クリック連打キュー（1.11.0）を外し毎クリック即 next/previous
// - 1.11.0: 矢印クリックのアニメ中断スナップを廃止し settle 後キューで速度を均一化
// - 1.10.0: groupCells=1 時は contain 無効化、peek 幅計算修正、percentPosition 無効化
// - 1.9.0: 矢印 next/previous の isWrap 修正、アニメ中連打・settling 固着を防止
// - 1.8.0: ready / select 後に矢印 disabled を再同期（非ループ時の初期配置）
// - 1.7.0: ループ settle 後の positionSlider を二重 rAF で安定化
// - 1.6.0: ドラッグ中の誤クリック防止、ループ+peek 時の resize 抑制
// - 1.5.0: groupCells を data 属性から独立読み込み（列数と分離）
// - 1.4.0: ループ時は contain を無効化（gap ずれ防止）
// - 1.3.0: __track 分離、初期化前の高さ計測、viewport 手動補正
// - 1.2.0: imagesLoaded 明示連携、eager 読み込み、resize 補正（高さゼロ対策）
// - 1.0.1: section:unload 対応、imagesLoaded 有効化
// - 1.0.0: 初版（PC/SP 別 data 属性、テーマエディタ対応）

(function () {
  const MOBILE_MQ = window.matchMedia('(min-width: 750px)');
  const HK_FLICKITY_SELECTOR = 'hk-flickity-carousel';
  const CELL_SELECTOR = '.card, .hk-artwork-series-cards__card, .hk-mo-cards__card, .hk-mo-media--cell';
  const CELL_SELECTOR_GRID_GROUP = '.group-block, .card, .hk-artwork-series-cards__card, .hk-mo-cards__card, .hk-mo-media--cell';
  const CELL_SELECTOR_GRID_GROUP_FLICKITY = '.hk-flickity-cell';
  const ACTIVE_MARKER_SELECTOR =
    '.hk-artwork-series-card--active, .hk-mo-card--active, [class*="hk-artwork-series-card--active"], [class*="hk-mo-card--active"]';
  /** active セル reinforce — この時間を過ぎたら resize / imagesLoaded 監視を解除 */
  const ACTIVE_SELECT_REINFORCE_MS = 2500;
  /** Flickity 公式 default 3 — 縦スクロールのゆらぎでドラッグが始まりにくくする */
  const DEFAULT_DRAG_THRESHOLD = 12;

  /**
   * @param {HTMLElement} el
   * @returns {number}
   */
  function readDragThreshold(el) {
    const raw = (el.dataset.dragThreshold || '').trim();
    if (!raw) return DEFAULT_DRAG_THRESHOLD;

    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : DEFAULT_DRAG_THRESHOLD;
  }

  /**
   * @param {HTMLElement} el
   * @returns {string}
   */
  function getCellSelector(el) {
    return el.classList.contains('hk-flickity-carousel--grid-group')
      ? CELL_SELECTOR_GRID_GROUP
      : CELL_SELECTOR;
  }

  /**
   * @param {HTMLElement} el
   * @returns {boolean}
   */
  function isGridGroupCarousel(el) {
    return el.classList.contains('hk-flickity-carousel--grid-group');
  }

  /**
   * @param {HTMLElement} el
   * @returns {boolean}
   */
  function isDesktop(el) {
    return MOBILE_MQ.matches;
  }

  /**
   * @param {HTMLElement} el
   * @returns {boolean}
   */
  function isCarouselActive(el) {
    const desktop = isDesktop(el);
    const mode = desktop ? el.dataset.layoutModeDesktop : el.dataset.layoutModeMobile;
    return !mode || mode === 'carousel';
  }

  /**
   * @param {HTMLElement} el
   * @returns {Record<string, unknown>}
   */
  function readOptions(el) {
    const desktop = isDesktop(el);

    const groupCells = desktop
      ? parseInt(el.dataset.groupCellsDesktop || '1', 10)
      : parseInt(el.dataset.groupCellsMobile || '1', 10);

    const autoplay = parseInt(el.dataset.autoplay || '0', 10);
    const wrapAround =
      (desktop ? el.dataset.wrapAroundDesktop : el.dataset.wrapAroundMobile) === 'true';
    const containSetting =
      (desktop ? el.dataset.containDesktop : el.dataset.containMobile) === 'true';

    // groupCells=1 は1枚ずつ送る。contain 有効だと (枚数-列数) で止まり PC 4列時に早く端に達する
    const effectiveContain = wrapAround ? false : containSetting && groupCells > 1;

    return {
      cellSelector: getCellSelector(el),
      groupCells: groupCells > 0 ? groupCells : 1,
      cellAlign: desktop ? el.dataset.cellAlignDesktop || 'left' : el.dataset.cellAlignMobile || 'left',
      contain: effectiveContain,
      wrapAround,
      freeScroll: (desktop ? el.dataset.freeScrollDesktop : el.dataset.freeScrollMobile) === 'true',
      pageDots: (desktop ? el.dataset.pageDotsDesktop : el.dataset.pageDotsMobile) === 'true',
      prevNextButtons: false,
      adaptiveHeight: el.dataset.adaptiveHeight === 'true',
      percentPosition: false,
      draggable: '>1',
      dragThreshold: readDragThreshold(el),
      autoPlay: autoplay > 0 ? autoplay : false,
      imagesLoaded: true,
    };
  }

  class HkFlickityCarousel extends HTMLElement {
    /** @type {HTMLElement | null} */
    #track = null;

    /** @type {import('flickity').default | null} */
    #flickity = null;

    /** @type {(() => void) | null} */
    #onMqChange = null;

    /** @type {((event: Event) => void) | null} */
    #onSectionUnload = null;

    /** @type {(() => void) | null} */
    #imagesLoadedCleanup = null;

    /** @type {(() => void) | null} */
    #dragClickCleanup = null;

    /** @type {(() => void) | null} */
    #loopStabilizerCleanup = null;

    /** @type {boolean} */
    #isDragging = false;

    /** @type {boolean} */
    #isSettling = false;

    /** @type {((event: Event) => void) | null} */
    #clickBlocker = null;

    /** @type {ReturnType<typeof setTimeout> | null} */
    #settlingSafetyTimer = null;

    /** @type {(() => void) | null} */
    #stretchCleanup = null;

    /** @type {(() => void) | null} */
    #mediaLoadedCleanup = null;

    /** @type {(() => void) | null} */
    #activeCellSelectCleanup = null;

    /** @type {boolean} */
    #activeSelectUserEngaged = false;

    /** @type {MutationObserver | null} */
    #designModeObserver = null;

    /** @type {MutationObserver | null} */
    #designModeShellObserver = null;

    /** @type {ReturnType<typeof setTimeout> | null} */
    #designModeRefreshTimer = null;

    /** @type {boolean} */
    #designModeRefreshPaused = false;

    /** @type {boolean} */
    #stretchSyncing = false;

    /** @type {number} */
    #stretchRetryCount = 0;

    /** @type {number} */
    #lastStretchHeightPx = 0;

    /** @type {ReturnType<typeof setTimeout> | null} */
    #stretchProgressTimer = null;

    /** @type {MutationObserver | null} */
    #tabPanelObserver = null;

    /** @type {MutationObserver | null} */
    #deferredDialogObserver = null;

    connectedCallback() {
      this.#track = this.querySelector('.hk-flickity-carousel__track');
      this.#prepareImages();

      this.#onMqChange = () => this.#reinit();
      this.#onSectionUnload = (event) => {
        if (event.target instanceof HTMLElement && event.target.contains(this)) {
          this.#destroy();
        }
      };
      MOBILE_MQ.addEventListener('change', this.#onMqChange);

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:unload', this.#onSectionUnload);
        this.#bindDesignModeRefresh();
      }

      this.#bindTabPanelVisibility();
      this.#waitAndInit();
    }

    disconnectedCallback() {
      this.#unbindTabPanelVisibility();
      this.#unbindDeferredDialogOpen();
      this.#unbindDesignModeRefresh();
      this.#destroy();

      if (this.#onMqChange) {
        MOBILE_MQ.removeEventListener('change', this.#onMqChange);
      }

      if (this.#onSectionUnload) {
        document.removeEventListener('shopify:section:unload', this.#onSectionUnload);
      }

      this.#track = null;
    }

    /**
     * テーマエディタ — layout data 属性 / shell style のみ監視（Flickity 自身の DOM 変更は無視）
     */
    #bindDesignModeRefresh() {
      if (!window.Shopify?.designMode) return;

      this.#unbindDesignModeRefresh();

      const scheduleRefresh = () => {
        if (this.#designModeRefreshPaused || this.#isDragging || this.#isSettling) return;

        if (this.#designModeRefreshTimer) {
          clearTimeout(this.#designModeRefreshTimer);
        }

        this.#designModeRefreshTimer = setTimeout(() => {
          this.#designModeRefreshTimer = null;
          if (this.#designModeRefreshPaused || this.#isDragging || this.#isSettling) return;
          this.#track = this.querySelector('.hk-flickity-carousel__track');
          this.refresh();
        }, 200);
      };

      /** @param {MutationRecord[]} records */
      const onShellStyleChange = (records) => {
        const changed = records.some(
          (record) =>
            record.type === 'attributes' &&
            record.attributeName === 'style' &&
            record.oldValue !== (record.target instanceof HTMLElement ? record.target.getAttribute('style') : null)
        );
        if (changed) scheduleRefresh();
      };

      this.#designModeObserver = new MutationObserver(scheduleRefresh);
      this.#designModeObserver.observe(this, {
        attributes: true,
        attributeFilter: [
          'data-layout-mode-desktop',
          'data-layout-mode-mobile',
          'data-group-cells-desktop',
          'data-group-cells-mobile',
          'data-cell-align-desktop',
          'data-cell-align-mobile',
          'data-contain-desktop',
          'data-contain-mobile',
          'data-wrap-around-desktop',
          'data-wrap-around-mobile',
          'data-free-scroll-desktop',
          'data-free-scroll-mobile',
          'data-adaptive-height',
          'data-autoplay',
          'data-drag-threshold',
        ],
      });

      const shell = this.closest('.hk-grid-group-shell');
      if (shell instanceof HTMLElement) {
        this.#designModeShellObserver = new MutationObserver(onShellStyleChange);
        this.#designModeShellObserver.observe(shell, {
          attributes: true,
          attributeFilter: ['style'],
          attributeOldValue: true,
        });
      }
    }

    #pauseDesignModeRefresh() {
      this.#designModeRefreshPaused = true;
    }

    #resumeDesignModeRefreshSoon() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.#designModeRefreshPaused = false;
        });
      });
    }

    #unbindDesignModeRefresh() {
      if (this.#designModeRefreshTimer) {
        clearTimeout(this.#designModeRefreshTimer);
        this.#designModeRefreshTimer = null;
      }

      this.#designModeObserver?.disconnect();
      this.#designModeObserver = null;
      this.#designModeShellObserver?.disconnect();
      this.#designModeShellObserver = null;
      this.#designModeRefreshPaused = false;
    }

    #prepareImages() {
      this.querySelectorAll('img').forEach((img) => {
        if (img.loading === 'lazy') {
          img.loading = 'eager';
        }
      });
    }

    #waitAndInit() {
      const start = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (this.#isLayoutDeferred()) {
              this.#bindDeferredDialogOpen();
              this.#syncSingleCellState();
              this.#syncArrowVisibility();
              return;
            }
            this.#init();
          });
        });
      };

      const tryStart = () => {
        if (typeof window.Flickity !== 'undefined') {
          start();
          return true;
        }
        return false;
      };

      if (tryStart()) return;

      const onScriptReady = () => {
        tryStart();
      };

      if (document.readyState === 'complete') {
        let attempts = 0;
        const interval = setInterval(() => {
          if (tryStart() || ++attempts >= 50) {
            clearInterval(interval);
          }
        }, 100);
        return;
      }

      window.addEventListener('load', onScriptReady, { once: true });
    }

    /** fetch 注入後など — 外部から再初期化 */
    refresh() {
      this.#reinit();
    }

    /** タブ表示後など — レイアウト確定後に init / reinit @param {number} [retryCount] */
    initWhenVisible(retryCount = 0) {
      if (this.#isLayoutDeferred()) {
        this.#bindDeferredDialogOpen();
        this.#syncSingleCellState();
        this.#syncArrowVisibility();
        return;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (this.#isLayoutDeferred()) return;

          const layoutRoot = this.closest('.hk-tab-target') || this;
          if (
            layoutRoot instanceof HTMLElement &&
            layoutRoot.offsetWidth === 0 &&
            retryCount < 12 &&
            !this.#isInClosedDialog()
          ) {
            window.setTimeout(() => this.initWhenVisible(retryCount + 1), 50);
            return;
          }

          if (this.#flickity) {
            const viewport = this.#viewport();
            if (viewport && viewport.offsetHeight === 0) {
              this.#reinit();
            } else {
              this.syncLayout();
              this.syncChrome();
            }
            return;
          }

          this.#init();
        });
      });
    }

    #unbindTabPanelVisibility() {
      this.#tabPanelObserver?.disconnect();
      this.#tabPanelObserver = null;
    }

    #bindTabPanelVisibility() {
      const tabTarget = this.closest('.hk-tab-target');
      if (!(tabTarget instanceof HTMLElement)) return;
      if (this.#tabPanelObserver) return;

      /** @param {MutationRecord[]} records */
      const onHiddenChange = (records) => {
        const becameVisible = records.some(
          (record) =>
            record.type === 'attributes' &&
            record.attributeName === 'hidden' &&
            record.target instanceof HTMLElement &&
            !record.target.hidden
        );

        if (becameVisible) {
          this.initWhenVisible();
        }
      };

      this.#tabPanelObserver = new MutationObserver(onHiddenChange);
      this.#tabPanelObserver.observe(tabTarget, {
        attributes: true,
        attributeFilter: ['hidden'],
      });
    }

    /** stretch 高さ・viewport を再同期（モーダル注入後など） */
    syncLayout() {
      if (!this.#flickity) return;
      this.#stretchRetryCount = 0;
      this.#flickity.resize();
      this.#syncStretchHeights();
    }

    /** 矢印表示・単一セル class だけ同期（Flickity 未読込でも可） */
    syncChrome() {
      this.#track = this.querySelector('.hk-flickity-carousel__track');
      this.#syncSingleCellState();
      this.#syncArrowVisibility();
    }

    /** @returns {boolean} */
    #isInHiddenTabPanel() {
      const tabTarget = this.closest('.hk-tab-target');
      if (!(tabTarget instanceof HTMLElement)) return false;
      if (tabTarget.hidden) return true;

      const section = tabTarget.closest('.shopify-section');
      const tabsRoot = section?.querySelector('[data-hk-category-tabs]');
      if (tabsRoot instanceof HTMLElement && !tabsRoot.classList.contains('hk-category-tabs--initialized')) {
        return true;
      }

      return false;
    }

    /** @returns {boolean} */
    #isInClosedDialog() {
      const dialog = this.closest('dialog');
      return dialog instanceof HTMLDialogElement && !dialog.open;
    }

    /** @returns {boolean} */
    #isInHiddenAncestor() {
      let el = this.parentElement;
      while (el) {
        if (el instanceof HTMLElement && el.hidden) return true;
        el = el.parentElement;
      }
      return false;
    }

    /** @returns {boolean} */
    #isLayoutDeferred() {
      return this.#isInHiddenTabPanel() || this.#isInClosedDialog() || this.#isInHiddenAncestor();
    }

    #unbindDeferredDialogOpen() {
      this.#deferredDialogObserver?.disconnect();
      this.#deferredDialogObserver = null;
    }

    #bindDeferredDialogOpen() {
      const dialog = this.closest('dialog');
      if (!(dialog instanceof HTMLDialogElement) || this.#deferredDialogObserver) return;

      /** @param {MutationRecord[]} records */
      const onDialogOpen = (records) => {
        const opened = records.some(
          (record) =>
            record.type === 'attributes' &&
            record.attributeName === 'open' &&
            dialog.open
        );

        if (opened) {
          this.initWhenVisible();
        }
      };

      this.#deferredDialogObserver = new MutationObserver(onDialogOpen);
      this.#deferredDialogObserver.observe(dialog, {
        attributes: true,
        attributeFilter: ['open'],
      });
    }

    #init() {
      if (this.#flickity || typeof window.Flickity === 'undefined' || !this.#track) return;
      if (this.#isLayoutDeferred()) {
        this.#bindDeferredDialogOpen();
        this.#syncSingleCellState();
        this.#syncArrowVisibility();
        return;
      }
      this.#syncSingleCellState();

      if (!isCarouselActive(this)) {
        this.#syncArrowVisibility();
        return;
      }

      if (!this.#hasMultipleCells()) {
        this.#syncArrowVisibility();
        return;
      }

      this.#prepareImages();
      this.#markFlickityCells();
      const initOptions = this.#readInitOptions();
      if (isGridGroupCarousel(this)) {
        initOptions.cellSelector = CELL_SELECTOR_GRID_GROUP_FLICKITY;
      }
      this.#flickity = new window.Flickity(this.#track, initOptions);

      this.#bindCustomArrows();
      this.#syncArrowVisibility();
      this.#bindImagesLoaded();
      this.#bindMediaLoaded();
      this.#bindDragClickGuard();
      this.#bindLoopStabilizer();
      this.#bindStretchHeights();
      this.#selectActiveCell();
    }

    /**
     * Flickity 初期化用 options（URL active があれば initialIndex を付与）
     *
     * @returns {Record<string, unknown>}
     */
    #readInitOptions() {
      const options = readOptions(this);

      if (!this.#findActiveMarker()) {
        return options;
      }

      const slideIndex = this.#resolveActiveSlideIndexFromDom(options.groupCells);
      if (slideIndex != null && slideIndex > 0) {
        options.initialIndex = slideIndex;
        return options;
      }

      // index 0 でも groupCells>1 時は selectCell の方が正確なことがある
      options.initialIndex = ACTIVE_MARKER_SELECTOR;
      return options;
    }

    /**
     * @returns {HTMLElement | null}
     */
    #findActiveMarker() {
      const track = this.#track;
      if (!track) return null;

      const hashId = this.#readHashAnchorId();
      if (hashId) {
        try {
          const inTrack = track.querySelector(`#${CSS.escape(hashId)}`);
          if (inTrack instanceof HTMLElement) return inTrack;
        } catch {
          /* CSS.escape 非対応時は getElementById で包含確認 */
        }

        const docEl = document.getElementById(hashId);
        if (docEl instanceof HTMLElement && track.contains(docEl)) return docEl;
      }

      const marker = track.querySelector(ACTIVE_MARKER_SELECTOR);
      return marker instanceof HTMLElement ? marker : null;
    }

    /**
     * active マーカーに対応する Flickity セル要素（親 group-block 内なども解決）
     *
     * @returns {HTMLElement | null}
     */
    #resolveActiveCellElement() {
      const marker = this.#findActiveMarker();
      if (!marker) return null;

      const flkty = this.#flickity;
      if (flkty?.cells?.length) {
        for (const cell of flkty.cells) {
          const el = cell.element;
          if (!(el instanceof HTMLElement)) continue;
          if (el === marker || el.contains(marker)) return el;
        }
      }

      const cells = this.#getCountableCells();
      if (cells.includes(marker)) return marker;

      return cells.find((cell) => cell.contains(marker)) ?? null;
    }

    /**
     * @param {number | string | boolean | undefined} groupCells
     * @returns {number | null}
     */
    #resolveActiveSlideIndexFromDom(groupCells) {
      const cellEl = this.#resolveActiveCellElement();
      if (!cellEl) return null;

      const flkty = this.#flickity;
      if (flkty) {
        const cell = flkty.getCell?.(cellEl);
        if (cell) {
          const slideIndex = flkty.getCellSlideIndex?.(cell);
          if (typeof slideIndex === 'number' && slideIndex >= 0) {
            return slideIndex;
          }
        }
      }

      const cells = this.#getCountableCells();
      const cellIndex = cells.indexOf(cellEl);
      if (cellIndex < 0) return null;

      const gc = Math.max(1, parseInt(String(groupCells || 1), 10) || 1);
      return Math.floor(cellIndex / gc);
    }

    /**
     * URL 一致 active の reinforce 監視を解除し、以降はユーザー操作を優先
     */
    #markActiveSelectUserEngaged() {
      this.#activeSelectUserEngaged = true;
      this.#activeCellSelectCleanup?.();
      this.#activeCellSelectCleanup = null;
    }

    /** アンカー遷移・外部同期用 — reinforce を止めてユーザー選択を優先 */
    engageUserNavigation() {
      this.#markActiveSelectUserEngaged();
    }

    /**
     * @returns {string}
     */
    #readHashAnchorId() {
      const raw = window.location.hash?.slice(1);
      if (!raw) return '';

      try {
        return decodeURIComponent(raw);
      } catch {
        return raw;
      }
    }

    /**
     * URL 一致の active セルを初期表示（作品シリーズ / メタオブジェクトカード）
     */
    #selectActiveCell() {
      this.#activeCellSelectCleanup?.();
      this.#activeCellSelectCleanup = null;

      const flkty = this.#flickity;
      const track = this.#track;
      if (!flkty || !track || !this.#findActiveMarker() || this.#activeSelectUserEngaged) return;

      const runSelect = (instant = true) => {
        if (this.#flickity !== flkty || this.#activeSelectUserEngaged) return;

        const savedScroll = this.#getPageScroll();
        const cellEl = this.#resolveActiveCellElement();
        if (!cellEl) return;

        if (typeof flkty.selectCell === 'function') {
          flkty.selectCell(cellEl, instant, true);
        } else {
          const cell = flkty.getCell?.(cellEl);
          if (!cell) return;

          const slideIndex = flkty.getCellSlideIndex?.(cell);
          if (slideIndex >= 0 && flkty.selectedIndex !== slideIndex) {
            flkty.select(slideIndex, instant, true);
          }
        }

        if (typeof flkty.reposition === 'function') {
          flkty.reposition();
        }

        this.#restorePageScrollSoon(savedScroll);
      };

      const cleanups = [];
      let reinforceCount = 0;
      const MAX_REINFORCE = 4;

      const reinforceSelect = () => {
        if (this.#activeSelectUserEngaged || reinforceCount >= MAX_REINFORCE) return;
        reinforceCount += 1;
        runSelect(true);
      };

      const endReinforcePhase = () => {
        cleanups.forEach((cleanup) => cleanup());
        if (this.#activeCellSelectCleanup === endReinforcePhase) {
          this.#activeCellSelectCleanup = null;
        }
      };

      const scheduleSelect = () => {
        runSelect(true);
        requestAnimationFrame(() => {
          runSelect(true);
          requestAnimationFrame(() => reinforceSelect());
        });
      };

      scheduleSelect();

      let resizeTimer = null;
      const onResize = () => {
        if (this.#activeSelectUserEngaged || reinforceCount >= MAX_REINFORCE) {
          flkty.off('resize', onResize);
          return;
        }

        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          resizeTimer = null;
          reinforceSelect();
        }, 50);
      };
      flkty.on('resize', onResize);
      cleanups.push(() => {
        if (resizeTimer) clearTimeout(resizeTimer);
        flkty.off('resize', onResize);
      });

      const imagesLoaded = window.imagesLoaded;
      const imgTarget = track.querySelector('.flickity-slider') || track;

      if (typeof imagesLoaded === 'function' && imgTarget) {
        const instance = imagesLoaded(imgTarget);
        const onImagesDone = () => reinforceSelect();
        instance.on('always', onImagesDone);
        cleanups.push(() => instance.off('always', onImagesDone));
      }

      const phaseTimer = window.setTimeout(endReinforcePhase, ACTIVE_SELECT_REINFORCE_MS);
      cleanups.push(() => clearTimeout(phaseTimer));

      this.#activeCellSelectCleanup = endReinforcePhase;
    }

    #destroy() {
      this.#activeSelectUserEngaged = false;
      this.#activeCellSelectCleanup?.();
      this.#activeCellSelectCleanup = null;

      this.#imagesLoadedCleanup?.();
      this.#imagesLoadedCleanup = null;

      this.#mediaLoadedCleanup?.();
      this.#mediaLoadedCleanup = null;

      this.#dragClickCleanup?.();
      this.#dragClickCleanup = null;

      this.#loopStabilizerCleanup?.();
      this.#loopStabilizerCleanup = null;

      this.#stretchCleanup?.();
      this.#stretchCleanup = null;
      this.#clearStretchHeights();

      if (this.#settlingSafetyTimer) {
        clearTimeout(this.#settlingSafetyTimer);
        this.#settlingSafetyTimer = null;
      }
      this.#isSettling = false;

      this.#removeClickBlocker();
      this.#clearFlickityCellMarks();

      if (!this.#flickity) {
        this.#syncSingleCellState();
        this.#syncArrowVisibility();
        return;
      }

      this.#flickity.destroy();
      this.#flickity = null;
      this.#syncSingleCellState();
      this.#syncArrowVisibility();
    }

    #reinit() {
      const pauseDesignMode = window.Shopify?.designMode;
      if (pauseDesignMode) this.#pauseDesignModeRefresh();

      this.#destroy();
      this.#track = this.querySelector('.hk-flickity-carousel__track');
      if (isCarouselActive(this)) {
        this.#init();
      } else {
        this.#syncSingleCellState();
        this.#syncArrowVisibility();
      }

      if (pauseDesignMode) this.#resumeDesignModeRefreshSoon();
    }

    #isStretch() {
      return this.classList.contains('hk-flickity-carousel--stretch');
    }

    #clearStretchHeights() {
      this.#lastStretchHeightPx = 0;
      this.style.removeProperty('--hk-flickity-cell-height');
      if (this.#flickity) {
        this.#flickity.cells.forEach((cell) => {
          cell.element.style.height = '';
          cell.element.style.minHeight = '';
        });
        return;
      }

      this.#track?.querySelectorAll(getCellSelector(this)).forEach((cell) => {
        if (cell instanceof HTMLElement) {
          cell.style.height = '';
          cell.style.minHeight = '';
        }
      });
    }

    /**
     * stretch 計測時 — height:fill の img/video は親 auto だと 0px になるため一時的に auto 化
     *
     * @param {HTMLElement} cell
     * @returns {number}
     */
    #measureStretchCellHeight(cell) {
      const mediaRestores = [];
      cell.querySelectorAll('.hk-mo-media__tag, .image-block__image').forEach((media) => {
        if (!(media instanceof HTMLElement)) return;
        mediaRestores.push({ media, height: media.style.height });
        media.style.height = 'auto';
      });

      cell.style.height = 'auto';
      const height = Math.max(cell.offsetHeight, cell.scrollHeight);

      mediaRestores.forEach(({ media, height: prevHeight }) => {
        media.style.height = prevHeight;
      });

      return height;
    }

    /**
     * @returns {HTMLElement[]}
     */
    #getStretchCellElements() {
      const fromFlickity = this.#flickity?.cells.map((cell) => cell.element) ?? [];
      const fromDom = this.#track
        ? Array.from(
            this.#track.querySelectorAll(
              '.flickity-slider > .hk-flickity-cell, .flickity-slider > .group-block, .flickity-slider > .card, .flickity-slider > .hk-artwork-series-cards__card, .flickity-slider > .hk-mo-cards__card, .flickity-slider > .hk-mo-media--cell'
            )
          ).filter((node) => node instanceof HTMLElement)
        : [];

      return [...new Set([...fromFlickity, ...fromDom])];
    }

    /**
     * @param {number} roundedMax
     * @param {HTMLElement[]} cells
     */
    #applyStretchHeights(roundedMax, cells) {
      const heightPx = `${roundedMax}px`;
      this.#lastStretchHeightPx = roundedMax;
      this.style.setProperty('--hk-flickity-cell-height', heightPx);
      cells.forEach((cell) => {
        cell.style.height = heightPx;
        cell.style.minHeight = heightPx;
      });
    }

    /**
     * 塗りつぶし: まず auto で自然高さを測り、全セルを同じ px 高に揃える（CSS height:100% ループを避ける）
     */
    #syncStretchHeights() {
      if (!this.#isStretch() || !this.#flickity || this.#stretchSyncing) return;

      const cells = this.#getStretchCellElements();
      if (!cells.length) return;

      this.#stretchSyncing = true;

      let maxHeight = 0;
      cells.forEach((cell) => {
        maxHeight = Math.max(maxHeight, this.#measureStretchCellHeight(cell));
      });

      const roundedMax = Math.ceil(maxHeight);

      if (maxHeight > 0) {
        const heightChanged = roundedMax !== this.#lastStretchHeightPx;
        this.#stretchRetryCount = 0;
        this.style.removeProperty('--hk-flickity-cell-height');
        this.#applyStretchHeights(roundedMax, cells);

        if (heightChanged && this.#flickity) {
          this.#flickity.resize();
        }
      } else if (this.#stretchRetryCount < 4) {
        this.#stretchRetryCount += 1;
        const retry = () => this.#syncStretchHeights();
        requestAnimationFrame(() => requestAnimationFrame(retry));
        window.setTimeout(retry, 200 * this.#stretchRetryCount);
      }

      this.#stretchSyncing = false;
    }

    #bindStretchHeights() {
      this.#stretchCleanup?.();

      if (!this.#isStretch() || !this.#flickity) return;

      const flkty = this.#flickity;
      const sync = () => this.#syncStretchHeights();

      flkty.on('ready', sync);
      flkty.on('select', sync);
      flkty.on('settle', sync);
      flkty.on('resize', sync);

      sync();

      this.#stretchCleanup = () => {
        flkty.off('ready', sync);
        flkty.off('select', sync);
        flkty.off('settle', sync);
        flkty.off('resize', sync);
      };
    }

    #bindImagesLoaded() {
      this.#imagesLoadedCleanup?.();

      const imagesLoaded = window.imagesLoaded;
      if (!this.#flickity || typeof imagesLoaded !== 'function') return;

      const target = this.#track?.querySelector('.flickity-slider') || this.#track;
      if (!target) return;

      const onProgress = () => {
        if (this.#stretchProgressTimer) {
          clearTimeout(this.#stretchProgressTimer);
        }
        this.#stretchProgressTimer = setTimeout(() => {
          this.#stretchProgressTimer = null;
          this.#syncStretchHeights();
        }, 80);
      };

      const instance = imagesLoaded(target);
      instance.on('progress', onProgress);
      instance.on('always', onProgress);

      this.#imagesLoadedCleanup = () => {
        if (this.#stretchProgressTimer) {
          clearTimeout(this.#stretchProgressTimer);
          this.#stretchProgressTimer = null;
        }
        instance.off('progress', onProgress);
        instance.off('always', onProgress);
      };
    }

    #bindMediaLoaded() {
      this.#mediaLoadedCleanup?.();
      if (!this.#track) return;

      const onMediaReady = () => {
        this.#stretchRetryCount = 0;
        this.#flickity?.resize();
        this.#syncStretchHeights();
      };

      const cleanups = [];
      this.#track.querySelectorAll('video').forEach((video) => {
        if (!(video instanceof HTMLVideoElement)) return;

        video.addEventListener('loadedmetadata', onMediaReady, { once: true });
        video.addEventListener('loadeddata', onMediaReady, { once: true });
        cleanups.push(() => {
          video.removeEventListener('loadedmetadata', onMediaReady);
          video.removeEventListener('loadeddata', onMediaReady);
        });

        if (video.readyState >= 1) {
          requestAnimationFrame(onMediaReady);
        }
      });

      this.#track.querySelectorAll('img').forEach((img) => {
        if (!(img instanceof HTMLImageElement)) return;

        if (img.complete) {
          requestAnimationFrame(onMediaReady);
          return;
        }

        img.addEventListener('load', onMediaReady, { once: true });
        cleanups.push(() => img.removeEventListener('load', onMediaReady));
      });

      this.#mediaLoadedCleanup = () => {
        cleanups.forEach((cleanup) => cleanup());
      };
    }

    #removeClickBlocker() {
      if (this.#clickBlocker) {
        document.removeEventListener('click', this.#clickBlocker, true);
        this.#clickBlocker = null;
      }
      this.removeAttribute('dragging');
      this.#isDragging = false;
    }

    /**
     * ドラッグ後の mouseup 由来クリックを抑止（Horizon slideshow と同趣旨）
     */
    #bindDragClickGuard() {
      this.#dragClickCleanup?.();

      const flkty = this.#flickity;
      if (!flkty) return;

      const onDragStart = () => {
        this.#markActiveSelectUserEngaged();
        this.#isDragging = true;
        this.setAttribute('dragging', '');

        if (!this.#clickBlocker) {
          this.#clickBlocker = (event) => {
            event.preventDefault();
            event.stopPropagation();
          };
          document.addEventListener('click', this.#clickBlocker, true);
        }
      };

      const onDragEnd = () => {
        this.#isDragging = false;
        this.removeAttribute('dragging');

        if (this.#clickBlocker) {
          const blocker = this.#clickBlocker;
          setTimeout(() => {
            document.removeEventListener('click', blocker, true);
            if (this.#clickBlocker === blocker) {
              this.#clickBlocker = null;
            }
          }, 100);
        }
      };

      const onUserPointer = () => {
        this.#markActiveSelectUserEngaged();
      };

      const onUiChange = () => {
        this.#markActiveSelectUserEngaged();
      };

      this.addEventListener('pointerdown', onUserPointer, { passive: true });

      flkty.on('dragStart', onDragStart);
      flkty.on('dragEnd', onDragEnd);
      flkty.on('uiChange', onUiChange);

      this.#dragClickCleanup = () => {
        this.removeEventListener('pointerdown', onUserPointer);
        flkty.off('dragStart', onDragStart);
        flkty.off('dragEnd', onDragEnd);
        flkty.off('uiChange', onUiChange);
        this.#removeClickBlocker();
      };
    }

    /**
     * @returns {HTMLElement | null}
     */
    #viewport() {
      const viewport = this.#track?.querySelector('.flickity-viewport');
      return viewport instanceof HTMLElement ? viewport : null;
    }

    /**
     * ループ時の wrap 直後に resize が走ると peek 端がちらつくため抑制
     */
    #bindLoopStabilizer() {
      this.#loopStabilizerCleanup?.();

      const flkty = this.#flickity;
      if (!flkty || !flkty.options.wrapAround) return;

      const clearSettlingSafety = () => {
        if (this.#settlingSafetyTimer) {
          clearTimeout(this.#settlingSafetyTimer);
          this.#settlingSafetyTimer = null;
        }
      };

      const onChange = () => {
        this.#isSettling = true;
        clearSettlingSafety();
        this.#viewport()?.classList.add('hk-flickity-viewport--transitioning');
        this.#settlingSafetyTimer = setTimeout(() => {
          this.#isSettling = false;
          this.#settlingSafetyTimer = null;
          this.#viewport()?.classList.remove('hk-flickity-viewport--transitioning');
        }, 600);
      };

      const onSettle = () => {
        clearSettlingSafety();
        flkty.positionSliderAtSelected();

        requestAnimationFrame(() => {
          flkty.positionSliderAtSelected();

          requestAnimationFrame(() => {
            this.#viewport()?.classList.remove('hk-flickity-viewport--transitioning');
            this.#isSettling = false;
            this.#syncArrowDisabled();
          });
        });
      };

      flkty.on('change', onChange);
      flkty.on('settle', onSettle);

      this.#loopStabilizerCleanup = () => {
        flkty.off('change', onChange);
        flkty.off('settle', onSettle);
        this.#viewport()?.classList.remove('hk-flickity-viewport--transitioning');
      };
    }

    /**
     * @returns {{ x: number, y: number }}
     */
    #getPageScroll() {
      const el = document.scrollingElement || document.documentElement;
      return { x: el.scrollLeft, y: el.scrollTop };
    }

    /**
     * @param {number} x
     * @param {number} y
     */
    #setPageScroll(x, y) {
      window.scrollTo({ left: x, top: y, behavior: 'instant' });
    }

    /**
     * @param {{ x: number, y: number }} saved
     */
    #restorePageScroll(saved) {
      const current = this.#getPageScroll();
      if (current.x !== saved.x || current.y !== saved.y) {
        this.#setPageScroll(saved.x, saved.y);
      }
    }

    /**
     * @param {{ x: number, y: number }} saved
     */
    #restorePageScrollSoon(saved) {
      this.#restorePageScroll(saved);
      requestAnimationFrame(() => this.#restorePageScroll(saved));
    }

    /**
     * @param {'previous' | 'next'} direction
     */
    #navigateByArrow(direction) {
      const flkty = this.#flickity;
      if (!flkty) return;

      this.#markActiveSelectUserEngaged();
      const isWrap = Boolean(flkty.options.wrapAround);

      if (direction === 'previous') {
        flkty.previous(isWrap);
      } else {
        flkty.next(isWrap);
      }
    }

    #bindCustomArrows() {
      const shell = this.closest('.hk-flickity-carousel-shell');
      if (!shell || !this.#flickity) return;

      shell.querySelectorAll('[data-hk-flickity-arrow]').forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) return;
        if (button.dataset.hkFlickityArrowBound === 'true') return;

        button.dataset.hkFlickityArrowBound = 'true';
        const direction = button.dataset.hkFlickityArrow;

        // 100vw ブレイクアウト上の矢印 focus で scrollIntoView が走るのを防ぐ
        button.addEventListener('mousedown', (event) => {
          event.preventDefault();
        });

        button.addEventListener('click', (event) => {
          event.preventDefault();
          if (direction === 'previous' || direction === 'next') {
            this.#navigateByArrow(direction);
          }
          if (document.activeElement === button) {
            button.blur();
          }
        });
      });

      this.#flickity.on('select', () => this.#syncArrowDisabled());
      this.#flickity.on('ready', () => this.#syncArrowDisabled());
      this.#flickity.on('settle', () => this.#syncArrowDisabled());
      this.#syncArrowDisabled();
    }

    #syncArrowVisibility() {
      const shell = this.closest('.hk-flickity-carousel-shell');
      if (!shell) return;

      const desktop = isDesktop(this);
      const iconsStyle = desktop ? this.dataset.iconsStyleDesktop : this.dataset.iconsStyleMobile;
      const show =
        Boolean(iconsStyle && iconsStyle !== 'none') &&
        isCarouselActive(this) &&
        this.#hasMultipleCells();

      shell.querySelectorAll('[data-hk-flickity-nav]').forEach((nav) => {
        if (!(nav instanceof HTMLElement)) return;
        const target = nav.dataset.hkFlickityNav;
        const visible =
          show &&
          ((target === 'desktop' && desktop) || (target === 'mobile' && !desktop));

        nav.hidden = !visible;
        nav.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }

    #clearFlickityCellMarks() {
      this.#track?.querySelectorAll('.hk-flickity-cell').forEach((el) => {
        el.classList.remove('hk-flickity-cell');
      });
    }

    /** hk-grid-group — Flickity は子孫 querySelectorAll するため、最外セルのみ .hk-flickity-cell を付与 */
    #markFlickityCells() {
      this.#clearFlickityCellMarks();
      if (!isGridGroupCarousel(this)) return;

      this.#getCountableCells().forEach((cell) => {
        cell.classList.add('hk-flickity-cell');
      });
    }

    /**
     * @returns {HTMLElement[]}
     */
    #getCountableCells() {
      if (!this.#track) return [];

      const sliderCells = this.#track.querySelectorAll('.flickity-slider > *');
      if (sliderCells.length > 0) {
        return Array.from(sliderCells).filter((node) => node instanceof HTMLElement);
      }

      if (isGridGroupCarousel(this)) {
        const marked = Array.from(
          this.#track.querySelectorAll(CELL_SELECTOR_GRID_GROUP_FLICKITY)
        ).filter((node) => node instanceof HTMLElement);
        if (marked.length > 0) {
          return marked;
        }
      }

      const selector = getCellSelector(this);
      const matched = Array.from(this.#track.querySelectorAll(selector)).filter(
        (node) => node instanceof HTMLElement
      );

      if (matched.length === 0) {
        return Array.from(this.#track.children).filter((child) => child instanceof HTMLElement);
      }

      return matched.filter((cell) => {
        let parent = cell.parentElement;
        while (parent && parent !== this.#track) {
          if (parent.matches(selector)) return false;
          parent = parent.parentElement;
        }
        return true;
      });
    }

    /**
     * @returns {number}
     */
    #countCells() {
      return this.#getCountableCells().length;
    }

    /**
     * @returns {boolean}
     */
    #hasMultipleCells() {
      return this.#countCells() > 1;
    }

    #syncSingleCellState() {
      const single = !this.#hasMultipleCells();
      this.classList.toggle('hk-flickity-carousel--single-cell', single);

      const shell = this.closest('.hk-flickity-carousel-shell');
      shell?.classList.toggle('hk-grid-group-shell--single-cell', single);
    }

    /**
     * contain 有効時は slides.length より前にスクロール端に達することがある
     * @param {import('flickity').default} flkty
     * @returns {boolean}
     */
    #isAtScrollEnd(flkty) {
      if (flkty.options.wrapAround) return false;

      if (flkty.selectedIndex >= flkty.slides.length - 1) return true;

      if (!flkty.options.contain) return false;

      const current = flkty.slides[flkty.selectedIndex];
      const next = flkty.slides[flkty.selectedIndex + 1];

      return Boolean(current && next && current.target === next.target);
    }

    /**
     * @param {import('flickity').default} flkty
     * @returns {boolean}
     */
    #isAtScrollStart(flkty) {
      if (flkty.options.wrapAround) return false;

      if (flkty.selectedIndex <= 0) return true;

      if (!flkty.options.contain) return false;

      const current = flkty.slides[flkty.selectedIndex];
      const prev = flkty.slides[flkty.selectedIndex - 1];

      return Boolean(current && prev && current.target === prev.target);
    }

    #syncArrowDisabled() {
      const shell = this.closest('.hk-flickity-carousel-shell');
      if (!shell || !this.#flickity) return;

      const flkty = this.#flickity;
      const prevButtons = shell.querySelectorAll('[data-hk-flickity-arrow="previous"]');
      const nextButtons = shell.querySelectorAll('[data-hk-flickity-arrow="next"]');
      const atStart = this.#isAtScrollStart(flkty);
      const atEnd = this.#isAtScrollEnd(flkty);

      prevButtons.forEach((button) => {
        if (button instanceof HTMLButtonElement) button.disabled = atStart;
      });
      nextButtons.forEach((button) => {
        if (button instanceof HTMLButtonElement) button.disabled = atEnd;
      });
    }
  }

  if (!customElements.get('hk-flickity-carousel')) {
    customElements.define('hk-flickity-carousel', HkFlickityCarousel);
  }

  /**
   * hk-flickity-carousel の矢印 / 単一セル class を同期（Flickity 不要）
   *
   * @param {ParentNode} [root]
   */
  function syncHkFlickityChrome(root = document) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    scope.querySelectorAll(HK_FLICKITY_SELECTOR).forEach((node) => {
      if (node instanceof HkFlickityCarousel && typeof node.syncChrome === 'function') {
        node.syncChrome();
      }
    });
  }

  /**
   * @param {ParentNode} [root]
   */
  function initHkFlickityWhenVisible(root = document) {
    const scope = root instanceof Element || root instanceof Document ? root : document;

    if (customElements.get('hk-flickity-carousel')) {
      scope.querySelectorAll(HK_FLICKITY_SELECTOR).forEach((node) => {
        if (node instanceof HTMLElement) {
          customElements.upgrade(node);
        }
      });
    }

    scope.querySelectorAll(HK_FLICKITY_SELECTOR).forEach((node) => {
      if (node instanceof HkFlickityCarousel && typeof node.initWhenVisible === 'function') {
        node.initWhenVisible();
      }
    });
  }

  /**
   * @param {ParentNode} [root]
   * @param {{ forceReinit?: boolean }} [options]
   * @returns {Promise<void>}
   */
  async function initHkFlickity(root = document, options = {}) {
    if (customElements.get('hk-flickity-carousel')) {
      await customElements.whenDefined('hk-flickity-carousel');
    }

    await new Promise((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
    });

    const scope = root instanceof Element || root instanceof Document ? root : document;
    const forceReinit = options.forceReinit === true;

    if (customElements.get('hk-flickity-carousel')) {
      scope.querySelectorAll(HK_FLICKITY_SELECTOR).forEach((node) => {
        if (node instanceof HTMLElement) {
          customElements.upgrade(node);
        }
      });
    }

    syncHkFlickityChrome(root);

    if (typeof window.Flickity === 'undefined') return;

    scope.querySelectorAll(HK_FLICKITY_SELECTOR).forEach((node) => {
      if (!(node instanceof HkFlickityCarousel)) return;

      if (forceReinit && typeof node.refresh === 'function') {
        node.refresh();
        return;
      }

      if (typeof node.initWhenVisible === 'function') {
        node.initWhenVisible();
      }
    });
  }

  /**
   * @param {ParentNode} [root]
   */
  function syncHkFlickityLayout(root = document) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    scope.querySelectorAll(HK_FLICKITY_SELECTOR).forEach((node) => {
      if (node instanceof HkFlickityCarousel && typeof node.syncLayout === 'function') {
        node.syncLayout();
      }
    });
  }

  window.HkFlickity = {
    init: initHkFlickity,
    initWhenVisible: initHkFlickityWhenVisible,
    syncChrome: syncHkFlickityChrome,
    syncLayout: syncHkFlickityLayout,
  };

  /** テーマエディタ — セクション再描画・ブロック設定変更後に一括 refresh */
  let designModeListenersBound = false;

  function bindDesignModeGlobalListeners() {
    if (designModeListenersBound || !window.Shopify?.designMode) return;
    designModeListenersBound = true;

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        initHkFlickity(event.target, { forceReinit: true });
      }
    });

    document.addEventListener('shopify:block:select', (event) => {
      const detail = /** @type {{ load?: boolean } | undefined} */ (event.detail);
      if (!detail?.load || !(event.target instanceof HTMLElement)) return;

      const section =
        event.target.closest('.shopify-section') ||
        event.target.closest('section.shopify-section') ||
        event.target;

      initHkFlickity(section, { forceReinit: true });
    });
  }

  bindDesignModeGlobalListeners();

  /**
   * カテゴリタブあり — tabs 確定後に init。なし — 即 init
   */
  function scheduleGlobalFlickityInit() {
    if (!document.querySelector('[data-hk-category-tabs]')) {
      return;
    }

    /** @param {number} [attempt] */
    const run = (attempt = 0) => {
      if (typeof window.Flickity === 'undefined') {
        if (attempt < 20) {
          window.setTimeout(() => run(attempt + 1), 50);
        }
        return;
      }
      initHkFlickityWhenVisible(document);
    };

    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      run();
    };
    document.addEventListener('hk-category-tabs:ready', runOnce, { once: true });
    window.setTimeout(runOnce, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleGlobalFlickityInit, { once: true });
  } else {
    scheduleGlobalFlickityInit();
  }
})();
